module.exports = __webpack_public_path__ + "static/media/emailModal.4a499cae.png";